import styled from '@emotion/styled';
import { YoutubeParagraphT } from 'types/shared/core/Post';

type PostContentYoutubePropsT = {
  paragraph: YoutubeParagraphT;
};

const StyledYoutubeParagraph = styled('div')`
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
  position: relative;
  & > iframe {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
  }
`;

function PostContentYoutube({ paragraph }: PostContentYoutubePropsT) {
  return (
    <StyledYoutubeParagraph>
      <iframe
        src={`https://www.youtube.com/embed/${paragraph.videoId}`}
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </StyledYoutubeParagraph>
  );
}
export default PostContentYoutube;
